import { useNavigate } from "react-router-dom";
import styles from "./CompanyHeader.module.css";


const IssuerNavigator = ({ title, handlestep, step, actions, state = {}, onBack }) => {
  const navigate = useNavigate();
  let isLoading = false

  // const actions = <div><button>Click on me</button></div>

  const handleClick=()=>{
    if(handlestep){

      handlestep(step);
      localStorage.removeItem("docID")
    }
    else if(step){
      navigate(step, {state})
    }
    else{
      onBack()
    }
  }
  return (
    <div className={[styles.h1, styles.actions].join(" ")} style={{ backgroundColor: "transparent" }}>
      <div className={styles.heading}>
        <div className={styles.button} onClick={() => handleClick()} style={{ border: "1px solid #D0D5DD", padding: "10px", backgroundColor: "white" }}>
          <img className={styles.arrowLeftIcon} loading="eager" alt="" src="/arrowleft.svg" />
        </div>
        <div className={styles.text}>
          <h2 className={styles.IssuerTitle}>
            {isLoading ? <div className="shimmer" style={{ width: "5rem" }}></div> : title ? title : `N/A`}
          </h2>
        </div>
      </div>
      {actions()}
    </div>
  );
};

export default IssuerNavigator;
